<template>
  <div>
    <div class="tab-title">我的账户</div>
    <div class="account-tab-container">
      <el-collapse v-model="activeNames">
        <el-collapse-item class="account-item" name="1">
          <template slot="title">
            <p class="item-title star-icon">星级</p>
          </template>
          <div class="star-item">
            <p class="subitem">我的星级</p>
            <div class="subitem-container">
              <p class="star-count-wrap">
                <span class="star-count">{{ userProfile.star }}</span>
              </p>
              <p class="explain">
                星级越高，可享受更多的永久存储空间及其它服务
              </p>
            </div>
          </div>
          <div class="star-item">
            <p class="subitem">升级</p>
            <div class="subitem-container">
              <p class="upgrade-count-wrap">
                当前拥有船票数：<span class="ticket-count">{{
                  userProfile.shipNumber
                }}</span>
                张， 每升 1 级需要
                <span class="upgrade-count">{{
                  storageConfig.shipToGrade
                }}</span>
                张船票
              </p>
              <p class="explain">
                <el-button
                  class="upgrade-btn"
                  type="primary"
                  @click="upgradeForUser"
                  >升级</el-button
                >
              </p>
            </div>
          </div>
          <div class="star-item">
            <p class="subitem">我的空间</p>
            <div class="subitem-container">
              <div class="space-progress-wrap">
                <p class="space-explain">
                  永久存储空间
                  <span class="space-index">{{ everStorageRate.text }}</span>
                </p>
                <el-progress
                  :percentage="everStorageRate.percentage"
                  :text-inside="true"
                  :stroke-width="15"
                  :color="spaceRateColor"
                ></el-progress>
              </div>
              <div class="space-progress-wrap">
                <p class="space-explain">
                  短期存储空间
                  <span class="space-index">{{ tempStorageRate.text }}</span>
                </p>
                <el-progress
                  :percentage="tempStorageRate.percentage"
                  :text-inside="true"
                  :stroke-width="15"
                  :color="spaceRateColor"
                ></el-progress>
              </div>
              <div class="space-declare-wrap">
                <p class="show-explain-wrap">
                  <el-button class="show-explain-btn" @click="switchShowExplain"
                    >空间说明</el-button
                  >
                </p>
                <div class="space-explain-wrap" v-show="showExplain">
                  <div class="space-explain-item">
                    <p class="explain-item-title">永久空间</p>
                    <p class="explain-item-content">
                      星级每提升 1 级，可获得
                      <span class="space-weight">{{
                        storageConfig.storageSize
                      }}</span
                      >M 永久空间。
                      该空间中的内容，永远不删除，子孙万代都可以查阅其中的信息。
                    </p>
                  </div>
                  <div class="space-explain-item">
                    <p class="explain-item-title">短期空间</p>
                    <p class="explain-item-content">
                      所有用户，可免费获得1G的短期存储空间，若需增容，可以购买。
                      已经购买的短期存储空间，到期不续费，将按上传时间先后顺序把旧的内容删除。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item class="account-item" name="2">
          <template slot="title">
            <p class="item-title purse-icon">钱包</p>
          </template>
          <div class="purse-item">
            <p class="subitem">我的零钱</p>
            <div class="subitem-container">
              <p class="star-count-wrap">
                <img
                  class="my-purse-icon"
                  src="../../assets/icon/user/cl_my_purse_big.png"
                />
              </p>
              <p class="explain purse-count">￥ {{ userProfile.money }} 元</p>
              <p class="explain-tip">提示：充值/提现等操作，请到手机端操作</p>
            </div>
          </div>
          <div class="purse-item">
            <p class="subitem">我的银行卡</p>
            <div class="subitem-container">
              <p class="explain-tip">
                提示：添加银行卡/解绑银行卡请到手机端操作
              </p>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item class="account-item" name="3">
          <template slot="title">
            <p class="item-title ticket-icon">船票</p>
          </template>
          <div class="ticket-item">
            <p class="subitem">我的船票</p>
            <div class="subitem-container">
              <p class="ticket-count-wrap">
                <img
                  class="my-ticket-icon"
                  src="../../assets/icon/user/cl_my_ticket_big.png"
                />
              </p>
              <p class="explain tickets-count">
                我的船票： {{ userProfile.shipNumber }} 张
              </p>
              <p>船票可用于升级，也可以出售或赠送给网友</p>
              <p class="explain-tip">提示：购买/赠送等操作，请到手机端操作</p>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item class="account-item" name="4">
          <template slot="title">
            <p class="item-title praise-icon">赞点</p>
          </template>
          <div class="praise-item">
            <p class="subitem">我的赞点</p>
            <div class="praise-container">
              <p class="explain">
                累计获得赞点：
                <span class="total-praise-count">{{
                  userProfile.totalPraiseNum
                }}</span>
              </p>
              <p class="explain">
                累计获得船票：
                <span class="total-ticket-count">{{
                  userProfile.totalShipNum
                }}</span>
              </p>
              <p class="explain">说明：</p>
              <p class="explain">
                {{ storageConfig.praiseToShip }} 赞点 = 1 张船票
              </p>
              <p class="explain">赞点 = 点赞数 - 踩点数</p>
              <p class="explain">
                当天分享的内容中取赞点数最高为有效赞点，其它内容获得的赞点数为无效赞点。
              </p>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../../utils/apiMap";
export default {
  name: "user-account",
  data() {
    return {
      activeNames: ["1"],
      spaceRateColor: "#3C9FAB",
      showExplain: false,
      storageConfig: {
        CostPerBuyStorageSize: "12",
        praiseToShip: "999", //一张船票需要多少赞（个）
        shipCost: "1", //一张船票多少钱（元）
        shipToGrade: "99", //每升一节消费船票（张）
        storageSize: "10", //用户升一级后用户的永久存储空间增加量 （兆|M）
      },
      tempStorageRate: {
        percentage: 0,
        text: "( 0 / 0 )",
      },
      everStorageRate: {
        percentage: 0,
        text: "( 0 / 0 )",
      },
      userProfile: {},
    };
  },
  mounted() {
    this.getUserProfile();
    this.getStorageConfig();
  },
  methods: {
    getUserProfile() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProfile"]["method"],
          url: apiMap["getProfile"]["url"],
          data: `token=${loginUser.token}`,
        })
        .then(function (response) {
          // console.log(response.data.result.data)
          if (response.data.result.statusCode == 1) {
            _this.userProfile = response.data.result.data;
            _this.initTempStorageRate();
            Store.dispatch("setUserProfile", response.data.result.data);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    switchShowExplain() {
      if (this.showExplain == true) {
        this.showExplain = false;
      } else {
        this.showExplain = true;
      }
    },
    getStorageConfig() {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["storageConfig"]["method"],
          url: apiMap["storageConfig"]["url"],
        })
        .then(function (response) {
          // console.log(response.data.result.data);
          if (response.data.result.statusCode == 1) {
            _this.storageConfig = response.data.result.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    refreshUserProfile() {
      this.$bus.$emit("update-user-profile");
    },
    upgradeForUser() {
      if (this.userProfile.shipNumber >= this.storageConfig.shipToGrade) {
        let _this = this;
        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["userUpgrade"]["method"],
            url: apiMap["userUpgrade"]["url"],
            data: `token=${loginUser.token}`,
          })
          .then(function (response) {
            // console.log(response.data.result.data)
            if (response.data.result.statusCode == 1) {
              _this.$alert("升级成功！", {
                confirmButtonText: "确定",
                showClose: false,
              });
              _this.getUserProfile();
              _this.$bus.$emit("update-user-profile");
            } else {
              _this.$alert(response.data.result.data, {
                confirmButtonText: "确定",
                showClose: false,
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$alert("您剩余的船票无法升级", {
          confirmButtonText: "确定",
          showClose: false,
        });
      }
    },
    initTempStorageRate() {
      // console.log(this.userProfile);
      var usedForeverSpace = parseFloat(this.userProfile.usedForeverSpaceMbNum);
      var totalForeverSpace = parseFloat(
        this.userProfile.totalForeverSpaceMbNum
      );
      var residueForeverRate = (
        (usedForeverSpace / totalForeverSpace) *
        100
      ).toFixed(2); //百分比
      if (isNaN(residueForeverRate)) {
        residueForeverRate = 0;
      }
      var userStorage = {};
      var foreverText =
        "( " + usedForeverSpace + " M / " + totalForeverSpace + " M )";
      userStorage.rate = residueForeverRate;
      userStorage.text = foreverText;
      userStorage.sum = totalForeverSpace;

      this.everStorageRate = {
        percentage: residueForeverRate * 1,
        text: foreverText,
      };

      var tempUsedSpaceNum = parseFloat(this.userProfile.tempUsedSpaceMBNum);
      var tempSpaceSizeNum = parseFloat(this.userProfile.tempSpaceSizeMbNum);
      var residueTempRate = (
        (tempUsedSpaceNum / tempSpaceSizeNum) *
        100
      ).toFixed(2);
      var tempText =
        "( " + tempUsedSpaceNum + " M / " + tempSpaceSizeNum + " M )";

      this.tempStorageRate = {
        percentage: residueTempRate * 1,
        text: tempText,
      };
    },
  },
};
</script>
<style scoped>
.tab-title {
  height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #1a70db;
}

.item-title {
  padding-left: 45px;
  font-size: 14px;
  font-weight: bold;
  font-family: serif;
  background-repeat: no-repeat;
}

.star-icon {
  background-image: url("../../assets/icon/user/cl_level_star.png");
  background-position: 15px 6px;
}

.purse-icon {
  background-image: url("../../assets/icon/user/cl_my_purse.png");
  background-position: 15px 5px;
}

.ticket-icon {
  background-image: url("../../assets/icon/user/cl_my_ticket.png");
  background-position: 15px 9px;
}

.praise-icon {
  background-image: url("../../assets/icon/user/cl_my_favour.png");
  background-position: 15px 6px;
}

.subitem {
  height: 30px;
  padding-left: 45px;
  line-height: 30px;
  font-size: 16px;
  background-color: #e9e9e9;
}

.subitem-container {
  padding: 16px 0;
  text-align: center;
  font-size: 16px;
}

.star-count {
  display: inline-block;
  height: 30px;
  padding-left: 35px;
  line-height: 30px;
  background-repeat: no-repeat;
  background-position: 10px 7px;
  background-image: url("../../assets/icon/user/cl_level_star.png");
}

.upgrade-btn {
  margin-top: 10px;
  padding: 3px 10px;
}

.space-progress-wrap {
  width: 80%;
  margin: 0 auto 10px;
}

.show-explain-btn {
  margin-top: 20px;
  padding: 3px 10px;
  color: #409eff;
}

.space-explain {
  margin: 5px 0;
}

.space-explain-item {
  margin-top: 20px;
}

.explain-item-title {
  font-weight: bold;
}

.space-index {
  font-weight: bold;
}

.explain-item-content {
  width: 50%;
  margin: 0 auto;
  text-align: left;
  text-indent: 28px;
}

.purse-count,
.tickets-count {
  font-weight: bold;
  font-size: 16px;
}

.explain-tip {
  color: #ff9800;
}

.praise-container {
  margin-left: 45px;
}

.praise-container .explain:first-child {
  margin-top: 6px;
}

.praise-container .explain {
  font-size: 16px;
}

.total-praise-count {
  color: #1a70db;
}

.total-ticket-count {
  color: #ff9800;
}

.account-tab-container {
  margin-bottom: 15px;
}
</style>